import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Input, message, Row } from "antd";
import { useSearchParams } from "react-router-dom";
import logo from "../assets/logo-with-name.png";
import { API_METHODS } from "../constants";
import useApi from "../hooks/useApi";

function PasswordReset() {
  let [searchParams, setSearchParams] = useSearchParams();
  const [messageApi, contextHolder] = message.useMessage();
  const [form] = Form.useForm();

  const [studentId, setStudentId] = useState(null);
  const [token, setToken] = useState(null);
  const [studentName, setstudentName] = useState(null);

  const [response, request] = useApi("/reset-password", null, API_METHODS.POST);

  const passwordReset = () => {
    form.validateFields().then((values) => {
      values.id = studentId;
      values.token = token;
      request(values, API_METHODS.POST, `/reset-password`);
    });
  };

  useEffect(() => {
    setStudentId(searchParams.get("id"));
    setToken(searchParams.get("token"));
    setstudentName(searchParams.get("name"));
  }, []);

  useEffect(() => {
    if (response.data) {
      messageApi.open({
        type: "success",
        content: "Password Changed Successfully",
      });
    }
  }, [response]);

  return (
    <Row
      type="flex"
      justify="center"
      align="middle"
      style={{ minHeight: "100vh" }}
    >
      {contextHolder}

      {studentId && studentName && token ? (
        <Col xs={20} sm={16} md={12} lg={10} xl={8}>
          <div style={{ textAlign: "center" }}>
            <img style={{ height: 250, backgroundColor: "black" }} src={logo} />
          </div>

          <Card title="Reset Password">
            <Form layout="vertical" onFinish={passwordReset} form={form}>
              <Form.Item
                label="Password"
                name="password"
                rules={[
                  { required: true, message: "Please input your password!" },
                  { max: 15 },
                ]}
              >
                <Input.Password />
              </Form.Item>
              <Form.Item
                label="Confirm Password"
                name="confirm_password"
                dependencies={["password"]}
                rules={[
                  {
                    required: true,
                    message: "Please input your Confirm password!",
                  },
                  { max: 15 },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || value === getFieldValue("password")) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("Passwords do not match!")
                      );
                    },
                  }),
                ]}
              >
                <Input.Password />
              </Form.Item>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ float: "right" }}
                >
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      ) : (
        <h1>Error</h1>
      )}
    </Row>
  );
}

export default PasswordReset;
